export const PASSENGER_TOKEN_KEY = "passengerToken";
export const PASSENGER_DATA_KEY = "passengerData";

export const getPassengerToken = () => localStorage.getItem(PASSENGER_TOKEN_KEY);
export const getPassengerData = () => {
  const raw = localStorage.getItem(PASSENGER_DATA_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setPassengerSession = ({ token, passengerData }) => {
  if (token) localStorage.setItem(PASSENGER_TOKEN_KEY, token);
  if (passengerData) localStorage.setItem(PASSENGER_DATA_KEY, JSON.stringify(passengerData));
};

export const clearPassengerSession = () => {
  localStorage.removeItem(PASSENGER_TOKEN_KEY);
  localStorage.removeItem(PASSENGER_DATA_KEY);
};
